import { render, staticRenderFns } from "./SincronizacaoPushAsync.vue?vue&type=template&id=47f80681&"
import script from "./SincronizacaoPushAsync.vue?vue&type=script&lang=js&"
export * from "./SincronizacaoPushAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports